import React, { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { registerMikrofonHinweis, MikrofonHinweis } from '../../lib/mikrofon';
import { MIcon } from '../../lib/micon';
import '../ld/ld-fenster.css';

// Welle H6: Einmal am App-Root gemountet (wie ConfirmHost). Zeigt den Hinweis bei
// verweigertem oder fehlendem Mikrofon — eigenes Overlay (zIndex 3000), damit er auch
// über offenen Sheets bedienbar bleibt. Portal direkt in <body>: offene Radix-/vaul-Sheets
// setzen aria-hidden auf die App-Wurzel — der Hinweis bliebe sonst für Screenreader unsichtbar.
export function MikrofonHinweisHost() {
  const [h, setH] = useState<MikrofonHinweis | null>(null);

  useEffect(() => {
    registerMikrofonHinweis(setH);
    return () => registerMikrofonHinweis(null);
  }, []);

  const schliessen = useCallback(() => setH(null), []);

  useEffect(() => {
    if (!h) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') schliessen(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [h, schliessen]);

  if (!h) return null;

  return createPortal(
    <div
      onClick={schliessen}
      // Radix-/vaul-Sheets schließen bei „Klick außerhalb“ — der Hinweis liegt außerhalb
      // des Sheets; ohne stopPropagation ginge beim Schließen auch der Diktat-Dialog zu
      onPointerDown={e => e.stopPropagation()}
      className="ld-modal-overlay"
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 3000, pointerEvents: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
    >
      {/* Welle Z3: K4-Rahmen, Texte unverändert */}
      <div onClick={e => e.stopPropagation()} role="alertdialog" aria-modal="true" aria-labelledby="ld-mikro-titel" className="ld-z3-dialog">
        <div className="ld-fe-kopf">
          <span className="ld-fe-kopf__icon" aria-hidden="true"><MIcon name="mic_off" size={20} /></span>
          <div className="ld-fe-kopf__text"><h3 id="ld-mikro-titel" className="ld-fe-kopf__titel">{h.titel}</h3></div>
          <button type="button" className="ld-fe-zu" aria-label="Schließen" onClick={schliessen}><MIcon name="close" size={20} /></button>
        </div>
        {h.anleitung.length > 0 && (
          <div className="ld-z3-dialog__text">
            <p style={{ margin: '0 0 6px', fontSize: 13, fontWeight: 600, color: 'var(--ld-text-secondary)' }}>So gibst du es frei:</p>
            {h.anleitung.map(z => (
              <p key={z} style={{ margin: '0 0 6px', fontSize: 14, lineHeight: 1.5, color: 'var(--ld-text-primary)' }}>{z}</p>
            ))}
          </div>
        )}
        <div className="ld-fe-fuss">
          <button type="button" className="ld-fe-knopf ld-fe-knopf--zweit" onClick={schliessen} autoFocus={!h.stattdessenTippen}>Schließen</button>
          {h.stattdessenTippen && (
            <button type="button" className="ld-fe-knopf ld-fe-knopf--haupt" autoFocus onClick={() => { const f = h.stattdessenTippen; schliessen(); f?.(); }}>Stattdessen tippen</button>
          )}
        </div>
      </div>
    </div>,
    document.body,
  );
}
